export default __webpack_public_path__ + "static/media/defaultPic.6a08ef5c.png";